import CommonError from '@/common/utils/errors/CommonError';

export default class JsonParseError extends CommonError {
  responseText: string;
  statusCode: number | undefined;

  constructor(responseText: string, status: number) {
    super('Can not parse payload. Expected JSON', 'JSON parse error');
    this.statusCode = status;
    this.responseText = responseText;
  }
}
